<div class="container-fluid mb-5 px-3">
    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>Insurance Policies</h1>
        </div>
        <div class="d-flex mt-2 me-1">
            <button mat-raised-button class="action-button d-flex col-auto align-items-center"
                (click)="onNewPolicyClick()">
                <mat-icon>add</mat-icon>
                Add Policy
            </button>
        </div>
    </div>
    <mat-card class="mt-3 pb-5">
        <div class="row justify-content-center p-3">
            <div class="row pt-2 align-items-center">
                <div class="col-lg-9 col-12 d-flex flex-column" id="filters-container">
                    <div class="d-flex flex-row align-items-center">
                        <!-- TODO: Reimplement Filter - losing sort after filter -->
                        <!-- <mat-icon *ngIf="filterDefinitions && filterDefinitions.length > 0" class="filter-icon">
                            filter_list
                        </mat-icon>
                        <app-data-table-filter *ngFor="let filterDefinition of filterDefinitions" class="filter"
                            [filterDefinition]="filterDefinition" [disable]="loading">
                            <ng-template #filters></ng-template>
                        </app-data-table-filter> -->
                    </div>
                </div>
                <div class="col-lg-3 col-12 my-2">
                    <mat-form-field appearance="outline" class="search-bar">
                        <mat-label class="search-bar-label">
                            <mat-icon class="search-icon">search</mat-icon>
                            <span>Search</span>
                        </mat-label>
                        <input matInput (keyup)="applySearch($event)" [(ngModel)]="searchKeyword">
                        <button type="button" *ngIf="searchKeyword" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex flex-row align-items-center pt-2" id="filter-pills-container">
                <app-data-table-filter-pill *ngFor="let filterPill of filterPills | keyvalue" [filterState]="filterPill.value"
                    (closeClickEvent)="onFilterPillCloseEvent($event)" [disable]="loading">
                </app-data-table-filter-pill>
            </div> 
            <div class="mt-2 mb-3">
                <div class="table-responsive">
                    <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
                        <ng-container [matColumnDef]="column.column" *ngFor="let column of displayedColumns">
                            <ng-container *ngIf="column.column !== 'action'">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.display }}</th>
                            </ng-container>
                            <ng-container *ngIf="column.column === 'action'">
                                <th mat-header-cell *matHeaderCellDef>{{ column.display }}</th>
                            </ng-container>
                            <ng-container [ngSwitch]="column.column">
                                <ng-container *ngSwitchCase="'pillStatus'">
                                    <td mat-cell *matCellDef="let element">
                                        <ng-container *ngIf="element[column.column]">
                                            <app-pill 
                                                [backgroundColor]="this.getPolicyStatusColor(element[column.column])"
                                                fontColor="white"
                                                [text]="element[column.column]"></app-pill>
                                        </ng-container>
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'contentsCoverage'">
                                    <td mat-cell *matCellDef="let element">
                                        {{ element[column.column] | currency }}
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'hoLiabilityCoverage'">
                                    <td mat-cell *matCellDef="let element">
                                        {{ element[column.column] | currency }}
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'dwellingCoverage'">
                                    <td mat-cell *matCellDef="let element">
                                        {{ element[column.column] | currency }}
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    @if(column.renderHtml) {
                                        <td mat-cell *matCellDef="let element" [innerHTML]="element[column.column]"></td>
                                    } @else {
                                        <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>
                                    }
                                </ng-container>
                            </ng-container>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnNames;" (click)="onRowClick(row)"></tr>
                        @if(loading && searchKeyword) {
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                    No data matching the filter "{{ searchKeyword }}"
                                </td>
                            </tr>
                        }
                        @if (loading && !searchKeyword) {
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                    Loading Policies..
                                </td>
                            </tr>
                        }
                    </table>
                </div>
                <div *ngIf="loading.value" class="d-flex justify-content-center">
                    <mat-spinner></mat-spinner>
                </div>
                <div class="d-flex paginator-row align-items-baseline">
                    <div class="col-10">
                        <mat-paginator (page)="onPageEvent($event)" [pageSizeOptions]="[10, 20, 50, 100]" [pageSize]="pageSize || 10" [length]="tableLength" aria-label="Select page" showFirstLastButtons></mat-paginator>
                    </div>
                    <div class="col-2 d-flex align-items-baseline">
                        <mat-form-field class="go-to" id="goToPage" style="width:90px;">
                            <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber">
                        </mat-form-field>
                        <button mat-raised-button (click)="onGoToPageClick()" class="action-button">Go</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
</div>